<template>
  <b-form-row class="mb-1 mt-1 contact-row">
    <b-col>
      <address>
        <strong>
          <a :href="`https://admin.hyper-script.ru/crm/contacts/${contact.id}`" target="_blank">
            {{ fullContact(contact) }}
          </a>
        </strong>

        <div v-if="contact.email && contact.email.trim().length > 1">
          <b-icon-envelope size="sm"></b-icon-envelope>
          <a :href="'mailto:'+contact.email" class="ml-1">{{ contact.email }}</a>
        </div>

        <div v-if="contact.phone && contact.phone.trim().length > 1">
          <b-icon-headphones size="sm"></b-icon-headphones>
          <span class="ml-1">{{ contact.phone }}</span>
        </div>

        <div v-if="chatLink">
          <b-icon-chat size="sm"></b-icon-chat>
          <a :href="chatLink" target="_blank" class="ml-1">Chatra</a>
        </div>

        <div v-if="contact.chat_id">
          <b-icon-chat size="sm"></b-icon-chat>
          <a :href="'https://crm-telegram.hyper-script.ru/chat/'+contact.chat_id" target="_blank" class="ml-1">Telegram</a>
        </div>
        <div v-if="contact.metaData && contact.metaData.yandexMetrikaClientId" title="Yandex Metrika ClientID">
          <b-icon-bar-chart size="sm"></b-icon-bar-chart>
          <span class="ml-1">{{ contact.metaData.yandexMetrikaClientId }}</span>
        </div>
      </address>
    </b-col>
    <b-col cols="1">
      <input type="hidden" v-model="contact.id"/>
      <b-button variant="outline" size="sm" v-on:click="removeItem">
        <b-icon-x aria-hidden="true"></b-icon-x>
      </b-button>
    </b-col>
  </b-form-row>
</template>

<script>
import commonMixin from '../mixins/common';

export default {
  name: "ContactListEntry",
  mixins: [commonMixin],
  props: ["contact"],
  data() {
    return {
      chatLink: null
    }
  },
  mounted() {
    this.fetchChatraLink()
  },
  methods: {
    removeItem() {
      this.$emit('removeItem', this.contact.id);
    },
    fetchChatraLink() {
      this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/chatra/chatlink', {
        params: {
          email: this.contact.email,
          phone: this.contact.phone
        }
      })
        .then((response) => {
          if (response.data.status === 200 && response.data.chatLink) {
            this.chatLink = response.data.chatLink;
          }
        })
        .catch(e => {
          console.error(e);
        })
    }
  }
}
</script>

<style scoped lang="scss">
.contact-row {
  padding: 0.25rem 0.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: .25rem;
  font-size: 0.95rem;
}
address {
  margin: 0;
}
</style>
